<template>
    <q-card flat bordered class="q-mb-md producto-panel-form__image-section">
        <q-card-section class="q-pa-none relative-position">
            <q-img :src="imgSrc" alt="product image" fit="contain" style="height: 180px; cursor: pointer;"
                @click="imageUpdate" class="rounded-borders">
                <template v-slot:error>
                    <div class="full-width full-height column items-center justify-center bg-grey-2">
                        <q-icon name="broken_image" size="48px" color="grey-5" />
                        <span class="text-caption text-grey-6 q-mt-xs">Sin imagen</span>
                    </div>
                </template>
                <div class="absolute-bottom text-center bg-black-5 backdrop-blur">
                    <q-btn flat dense icon="photo_camera" label="Cambiar imagen" color="white" size="sm"
                        @click.stop="imageUpdate" />
                </div>
            </q-img>
            <input type="file" ref="image" style="display: none" @change="onImageChange" />
        </q-card-section>
    </q-card>
</template>

<script setup>
import { computed } from "vue";
import { useImageUploader } from "@/composables/useImageUploader";
const props = defineProps({
    imagesPath: {
        type: String,
        required: true,
    },
    form: {
        type: Object,
        required: true,
    },
    parentProps: {
        type: Object,
        required: true,
    },
});
const imgSrc = computed(
    () => `${props.imagesPath}/${props.parentProps.producto.productoID}.webp?${random.value}` // Use random to force reload image`
);
const { image, onImageChange, imageUpdate, random } = useImageUploader(props.form, props.parentProps);
</script>

<style lang="scss" scoped></style>
